import React from 'react';
import classNames from 'classnames';

import { FeaturesSvgs } from '../FeaturesSvgs';
import { ArrowLink } from '../ArrowLink';
import {
  isIOS,
  isAndroidChrome,
} from '../../../../../helpers/serverRenderingUtils';

import { events } from '../../events';

import styles from './styles.sass';

function getSvgSize(pageWidth) {
  if (pageWidth < 600) return 'small';
  if (pageWidth < 768) return 'medium';
  return 'large';
}

const FeatureItem = ({
  alignImageRight,
  title,
  text,
  mobileText,
  svgType,
  linkUrl,
  svgWidths,
  mobileSvgWidths,
  pageWidth,
}) => {
  // design calls for different text and images for desktop and mobile
  // for some features. this will set the correct image sizing and text.
  const isMobile = isIOS() || isAndroidChrome();
  const displayText = isMobile && mobileText ? mobileText : text;
  const maxSvgWidth =
    isMobile && mobileSvgWidths
      ? mobileSvgWidths[getSvgSize(pageWidth)]
      : svgWidths[getSvgSize(pageWidth)];
  return (
    <div className={styles.FeatureItem}>
      <div
        className={classNames(styles.FeatureItemImage, {
          [styles.AlignImageRight]: alignImageRight,
        })}
      >
        <div
          className={styles.FeatureItemSvgWrapper}
          style={{ maxWidth: maxSvgWidth }}
        >
          <FeaturesSvgs svgType={svgType} />
        </div>
      </div>
      <div
        className={classNames(styles.FeatureItemContentContainer, {
          [styles.AlignTextLeft]: alignImageRight,
        })}
      >
        <h3 className={styles.FeatureItemHeader}>{title}</h3>
        <p className={styles.FeatureItemText}>{displayText}</p>
        <ArrowLink
          href={linkUrl}
          text="Read more"
          onClick={() => events.clickFeatureItemReadMore(svgType)}
        />
      </div>
    </div>
  );
};

export { FeatureItem };
